namespace Areas.NonCompliances {
    "use strict";


    $(() => init());

    function init() {
        const button: DevExpress.ui.dxDropDownButton = $("#NonComplianceReportsDropDownButton").dxDropDownButton("instance");

        if (!button) return;

        const items = [
            { text: "NonCompliance Report", icon: "doc", action: Areas.Report.gotoNonComplianceReport },
            { text: "NonCompliance Report Multiple (40 max)", icon: "doc", action: Areas.Report.gotoNonComplianceReportMultiple },
            { text: "NonCompliance Report All", icon: "doc", action: Areas.Report.gotoNonComplianceReportAll }
        ];

        button.option("items", items);

    }

    export function reportDropDownButtonClick(e) {
        e.itemData.action();
    }



}
